import { Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useActions } from '../../../../hooks/useActions';
import { useStore } from '../../../../hooks/useStore';
import { SaveIcon } from '../../../../lib/icons';
import Util from '../../../../misc/util';
import { useStepper } from '../../partials/actionStepperPartial';

export const UpdateEmployeesStepTwo: FC = () => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { selectedUsers, bulkUpdateType, bulkUpdateValue } = useActions();
  const { activeStep, setNextButtonConfig } = useStepper();

  useEffect(() => {
    setNextButtonConfig({
      text: t('common:SAVE'),
      startIcon: <SaveIcon />,
      endIcon: undefined
    });
  }, [activeStep]);

  return (
    <Typography paragraph>
      {t('employee:SELECTED_EMPLOYEES_SUMMARY', {
        count: selectedUsers?.length,
        context: bulkUpdateType,
        value: Util.getValueFromStore(bulkUpdateValue, bulkUpdateType, companyStore)
      })}
    </Typography>
  );
};
